import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButtonContainer } from './PrimaryButton.styles';

// Primary Button Component
const PrimaryButton = React.memo(
  ({ functionName, span, disabled = false, title = '', style }) => {
    return (
      <PrimaryButtonContainer
        onClick={functionName}
        disabled={disabled}
        style={style}
        title={title}
      >
        {span}
      </PrimaryButtonContainer>
    );
  }
);
PrimaryButton.displayName = 'PrimaryButton';
PrimaryButton.propTypes = {
  functionName: PropTypes.func,
  span: PropTypes.string,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  style: PropTypes.object,
};

export default React.memo(PrimaryButton);
